import styled from 'styled-components';

export const HomeWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  padding: 80px 0;
`

export const HeroSection = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  padding: 40px 0;
`

export const Container = styled.div`
  position: relative;
  z-index: 3;
  margin: 0 16px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 24px;
`

export const SectionsContainer = styled.div`
  position: relative;
  z-index: 3;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 24px;
`

export const MapPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-height: 400px;
  margin: 24px auto;
  
  border-radius: 8px;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`